import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class DashboardErrorBoundary extends Component<Props, State> {
  private recoveryTimer: number | null = null;

  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[Dashboard Error]', error, info);
    // Auto-recover after 5 seconds
    this.recoveryTimer = window.setTimeout(() => {
      this.setState({ hasError: false });
    }, 5000);
  }

  componentWillUnmount() {
    if (this.recoveryTimer !== null) {
      window.clearTimeout(this.recoveryTimer);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0d1b12',
            color: '#ffffff',
            fontSize: '32px',
            fontFamily: "'Inter', system-ui, sans-serif",
          }}
        >
          <p>Refreshing display...</p>
        </div>
      );
    }
    return this.props.children;
  }
}
